import uniq from 'lodash/uniq';

interface AssignedDoctorScope {
    id: string;
    isAssistant: boolean;
    selectedUserIds: string[];
}

// Same as default filters in the entries table
export function resolveAssignedDoctorIds({ id, isAssistant, selectedUserIds }: AssignedDoctorScope): string[] {
    return uniq([id, ...(isAssistant ? selectedUserIds : [])]);
}
